import { FEATURE_FLAGS, type FeatureFlag } from '@/config/featureFlags';

/**
 * Read a feature flag value. Stable per app lifecycle (env-based).
 * Usage: const metapersonOn = useFeatureFlag('METAPERSON_ENABLED');
 */
export function useFeatureFlag(flag: FeatureFlag): boolean {
  return FEATURE_FLAGS[flag];
}
